import {
  ArchiveBoxIcon,
  CodeBracketIcon,
  DocumentIcon,
  DocumentTextIcon,
  PhotoIcon,
  TableCellsIcon,
} from "@heroicons/react/24/outline";
import { FILE_KIND, fileKindFor } from "./document-utils";

// What a customer sends is a mixed bag: phone photos of a plan on the wall, a payroll
// register as a PDF, exports as CSV or XLSX, the odd JSON dump. A row of identical page
// icons makes that list harder to scan than it needs to be.
const KIND_ICON = {
  [FILE_KIND.image]: PhotoIcon,
  [FILE_KIND.table]: TableCellsIcon,
  [FILE_KIND.document]: DocumentTextIcon,
  [FILE_KIND.code]: CodeBracketIcon,
  [FILE_KIND.archive]: ArchiveBoxIcon,
  [FILE_KIND.file]: DocumentIcon,
} as const;

export const DocumentIconFor = ({
  contentType,
  fileName,
  className,
}: {
  contentType?: string | null;
  fileName?: string | null;
  className?: string;
}) => {
  const kind = fileKindFor(contentType, fileName);
  const Icon = KIND_ICON[kind];

  return <Icon data-file-kind={kind} className={className} />;
};
